import React from 'react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const scrollToForm = () => {
    document.getElementById('formulario')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  // Note for Lorena: Insert real testimonials from Jotform here.
  const testimonials = [{
    text: 'Nunca pensé que a mis 48 años podría sentirme con tanta energía. El programa me dio la estructura que necesitaba sin sentirme a dieta. Compartir mi historia me hace sentir que mi esfuerzo valió el doble.',
    name: 'María C.',
    details: '48 años • Miami, FL',
    program: 'RenuevaTE_90'
  }, {
    text: 'La menopausia me tenía agotada y frustrada con mi cuerpo. Lorena me enseñó que esta etapa es para renovarse, no para apagarse. Hoy me siento más fuerte que a mis 30.',
    name: 'Elena R.',
    details: '52 años • Houston, TX',
    program: 'Menopausia Activa'
  }, {
    text: 'Lo que más valoro es la comunidad. Ver a otras mujeres de mi edad logrando sus metas me dio el empujón que necesitaba. Ya no me siento sola en este proceso.',
    name: 'Carmen V.',
    details: '45 años • Bogotá, COL',
    program: 'RenuevaTE GLP-1'
  }, {
    text: 'Pensé que ya era tarde para cambiar mis hábitos. RenuevaTE_90 me demostró lo contrario. Mi digestión mejoró, mi piel brilla y recuperé mi confianza.',
    name: 'Patricia L.',
    details: '55 años • CDMX, MEX',
    program: 'RenuevaTE_90'
  }, {
    text: 'No es solo nutrición, es un cambio de mentalidad. Aprender a comer sin ser esclava de las calorías me devolvió la paz. Gracias Lorena por tu guía constante.',
    name: 'Ana S.',
    details: '42 años • Orlando, FL',
    program: 'RenuevaTE GLP-1'
  }, {
    text: 'Escribir mi testimonio me hizo darme cuenta de todo lo que he avanzado. Si mi historia puede inspirar a una sola mujer a empezar, todo habrá valido la pena.',
    name: 'Rosa M.',
    details: '50 años • San Juan, PR',
    program: 'Menopausia Activa'
  }];
  return <section className="py-24 px-6 bg-soft-gradient" data-id="element-259">
      <div className="max-w-7xl mx-auto flex flex-col items-center" data-id="element-260">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-champagne-gold font-montserrat font-semibold text-sm tracking-[0.2em] uppercase mb-4 text-center" data-id="element-261">
          Mujeres que ya compartieron
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-playfair font-bold text-deep-blue text-3xl md:text-[42px] leading-[1.2] text-center mb-4" data-id="element-262">
          Ellas Se Atrevieron
          <br data-id="element-263" />a Contar su Verdad
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="font-montserrat text-gray-text text-center mb-16" data-id="element-264">
          Sus palabras son reales. Sus nombres son reales. Sus resultados son
          reales.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full mb-16" data-id="element-265">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-luxury-card border-t-4 border-champagne-gold relative flex flex-col h-full" data-id="element-266">
              <span className="absolute top-4 left-4 font-cormorant text-champagne-gold/15 text-[120px] leading-none select-none" data-id="element-267">
                "
              </span>
              <p className="font-cormorant italic text-gray-text text-[18px] leading-[1.8] relative z-10 mb-6 flex-grow" data-id="element-268">
                {t.text}
              </p>

              <div className="w-full h-[1px] bg-champagne-gold/30 mb-6" data-id="element-269"></div>

              <div className="flex items-center gap-4" data-id="element-270">
                <div className="w-12 h-12 rounded-full bg-deep-blue flex items-center justify-center text-white font-playfair font-bold text-xl shrink-0" data-id="element-271">
                  {t.name.charAt(0)}
                </div>
                <div className="flex flex-col" data-id="element-272">
                  <span className="font-montserrat font-semibold text-deep-blue text-sm" data-id="element-273">
                    {t.name}
                  </span>
                  <span className="font-montserrat font-light text-gray-text text-xs mb-1" data-id="element-274">
                    {t.details}
                  </span>
                  <span className="bg-deep-blue text-white text-[11px] px-2 py-0.5 rounded-full w-fit font-montserrat" data-id="element-275">
                    {t.program}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center gap-6" data-id="element-276">
          <p className="font-cormorant italic text-gray-text text-xl" data-id="element-277">
            ¿Tu historia podría estar aquí?
          </p>
          <button onClick={scrollToForm} className="bg-cta-gradient text-white font-montserrat font-bold text-lg py-4 px-10 rounded-full shadow-cta-shadow hover:shadow-cta-shadow-hover hover:scale-105 transition-all duration-300" data-id="element-278">
            Sí, Quiero Compartir la Mía 💙
          </button>
        </motion.div>
      </div>
    </section>;
}